/**
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
**/
window.corpBehaviours = window.corpBehaviours || {};
corpBehaviours.mpinRegisterBehaviour = {
  properties: {
    selected: {
      type: Number,
      notify: true
    },
    show: {
      type: Boolean,
      notify: true
    },
    activateResponse: {
      type: Object,
      notify: true
    },
    otp: {
      type: String,
      notify: true
    }
  },
  postRequest: function () {
    var bodyDet = {
      "userId": this.mpinAuthList.userId,
      "orgId": this.mpinAuthList.userId,
      "mobileNumber": this.mpinAuthList.mobileNumber,
      "userType": this.mpinAuthList.userType,
      "deviceId": this.mpinAuthList.deviceId,
      "deviceName": this.mpinAuthList.deviceName,
      "deviceType": this.mpinAuthList.deviceType,
      "authenticationDetails": this.authorizationDetailsBody
    };
    bodyDet.authenticationDetails = sbEncrypt.encrypt(JSON.stringify(bodyDet.authenticationDetails));
    var self = this;
    var ajaxCall = document.createElement('oe-ajax');
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/UserDevices";
    ajaxCall.method = "post";
    ajaxCall.addEventListener('error', function (err) {
      self.ErrMsg = getLabel('m_genericError');
      self.fire('stop-processing-loader');

      if (err.detail.request.response && err.detail.request.response.error && err.detail.request.response.error.message) {
        self.ErrMsg = JSON.parse(err.detail.request.response.error.message.channelcontext).status != undefined ? JSON.parse(err.detail.request.response.error.message.channelcontext).status.message[0].messageDesc : err.detail.request.response.error.message;
      }

      self.fire('oe-show-error', {
        message: self.ErrMsg,
        forever: true,
        actionName: getLabel('b_OK'),
        callBack: function () {
          self.navigatePage();
        }
      });
    });
    ajaxCall.addEventListener('response', function (e) {
      // addImportLink('./node_modules/speedboat_ui/elements/mpin-set-password.js', true, function () {
      self.selectedPage = 5;
      self.fire('stop-processing-loader');
      self.activateResponse = {};
      self.activateResponse = e.detail.response;
      if (self.securityAnsBody != undefined && self.securityAnsBody.securityQuestionAnswers != undefined) self.gotoReset(); // });
    });

    oeAjaxEventListner(ajaxCall);
    self.fire('start-processing-loader');
    ajaxCall.body = document.getElementById('keyManagement').setSymKey(bodyDet);
    ajaxCall.generateRequest();
  },
  backToMyProfile: function () {
    window.oe_navigate_to('/profile', {
      "selectedPage": 2
    });
  },
  navigatePage: function () {
    if (!this.profilePage) {
      this.goToLoginPage();
    } else {
      this.backToMyProfile();
    }
  }
};
